export enum StructuredDataKeys {
  organization,
  home,
  taxon,
  product,
  breadcrumbs,
  faqPage,
  newsArticle,
}
